import { ProcessedRow } from '@import/interfaces/processed-row.interface';
import { ColumnType } from '../interfaces';

/**
 * Converts rows into properly serialized payloads for the importer APIs
 */
export const serializeRow = (type: string, humiColumns: ColumnType[], row: Array<string>): any => {
    const setValue = (object: object, properties: string[], value: string): object => {
        const [currentProperty, ...remainingProperties] = properties;

        if (remainingProperties.length === 0) {
            if (value === null || value === '') {
                return object;
            }

            object[currentProperty] = value;

            return object;
        }

        if (!object.hasOwnProperty(currentProperty)) {
            object[currentProperty] = {};
        }

        object[currentProperty] = {
            ...object[currentProperty],
            ...setValue(object[currentProperty], remainingProperties, value),
        };

        return object;
    };

    return {
        type: type,
        attributes: humiColumns.reduce((payload: any, humiColumn: ColumnType) => {
            const propertyPath = humiColumn.serializeName.split('.');
            return setValue(payload, propertyPath, row[humiColumn.csvColumn.index]);
        }, {}),
    };
};

export const serializePayload = (type: string, humiColumns: ColumnType[], rows: ProcessedRow[]): any => {
    return rows.map((row: ProcessedRow) => serializeRow(type, humiColumns, row.raw));
};
